import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../shared/hooks/useAuth";

import "../../shared/styles/UtillitiesComponent.css";
import "../../shared/styles/pages/Auth.css";

import logo_header_02 from "../../assets/logo_header_02.png";
import logo_black_02 from "../../assets/logo_black_02.png";
import logo_red_01 from "../../assets/logo_red_01.png";

import chicchic_login_logo from "../../assets/chicchic_login_logo.png";

export default function Register() {
  const { registerEmail, loginGoogle } = useAuth();
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showEmailForm, setShowEmailForm] = useState(false); // ⭐ toggle ฟอร์มอีเมล

  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from?.pathname || "/";

  const doRegister = async () => {
    try {
      setSubmitting(true);
      await registerEmail(email, password, displayName);
      // สมัครด้วยอีเมล → ให้ไปหน้า verify-email ตามเดิม
      // navigate("/verify-email");
      navigate("/");
    } catch (e) {
      alert(e.message);
    } finally {
      setSubmitting(false);
    }
  };

  const doRegisterWithGoogle = async () => {
    try {
      setSubmitting(true);
      await loginGoogle();
      // สมัครด้วย Google เสร็จ → กลับไปหน้าก่อนหน้า
      navigate(redirectTo, { replace: true });
    } catch (e) {
      alert(e.message);
      console.error(e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="auth-shell auth-shell-bubbles-register">
      {/* Bubbles */}
      {/* <div className="bubble bubble-1" />
      <div className="bubble bubble-2" />
      <div className="bubble bubble-3" />
      <div className="bubble bubble-4" />
      <div className="bubble bubble-5" />
      <div className="bubble bubble-6" />
      <div className="bubble bubble-7" /> */}

      <div className="auth-card auth-card-centered">
         {/* โลโก้ด้านบน */}
          <div className="auth-logo-wrapper">
            <img
              src={chicchic_login_logo}
              alt="ChicChic Logo"
              className="auth-logo-img"
            />
          </div>
        <h3 className="mb-2 text-center">สมัครสมาชิก</h3>
        <p className="text-center text-muted small mb-3">
          สมัครด้วย Google เพื่อยืนยันอีเมลอัตโนมัติ และเข้าสู่ระบบได้รวดเร็ว
        </p>

        {/* ===== ปุ่ม Google – เป็นวิธีหลัก ===== */}
        <div className="card mb-3">
          <div className="card-body">
            <button
            className="google-btn w-100"
            onClick={doRegisterWithGoogle}
            disabled={submitting}
          >
            <span className="google-btn-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
              </svg>
            </span>
            <span className="google-btn-text">สมัครสมาชิกด้วย Google</span>
          </button>
          </div>
        </div>

        {/* ลิงก์เล็ก ๆ สำหรับเปิด/ปิดฟอร์มอีเมล */}
        <div className="text-center mb-2">
          {!showEmailForm ? (
            <button
              type="button"
              className="btn btn-link p-0 small no-underline-link"
              onClick={() => setShowEmailForm(true)}
            >
              ไม่สะดวกใช้ Google? สมัครด้วยอีเมลแทน
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-link p-0 small no-underline-link"
              onClick={() => setShowEmailForm(false)}
            >
              ซ่อนฟอร์มสมัครด้วยอีเมล
            </button>
          )}
        </div>

        {/* ===== ฟอร์มสมัครด้วยอีเมล – แสดงเฉพาะเมื่อกดลิงก์ ===== */}
        {showEmailForm && (
          <div className="card mb-3">
            <div className="card-body">
              <h6 className="mb-3">สมัครด้วยอีเมล</h6>

              <input
                className="form-control mb-2"
                placeholder="ชื่อที่แสดง"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
              />

              <input
                className="form-control mb-2"
                type="email"
                placeholder="อีเมล"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <input
                className="form-control mb-3"
                type="password"
                placeholder="รหัสผ่าน"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <button
                className="btn btn-primary w-100"
                onClick={doRegister}
                disabled={submitting}
              >
                สมัครสมาชิกด้วยอีเมล
              </button>
            </div>
          </div>
        )}

        {/* ✅ ข้อความ Terms + Privacy */}
        <div className="text-center mt-4 mb-3">
          <small className="text-muted">
            การสมัครสมาชิกถือว่าคุณยอมรับ{" "}<br/>
            <Link to="/terms" className="no-underline-link">
              ข้อกำหนดการให้บริการ
            </Link>{" "}
            และ{" "}
            <Link to="/privacy" className="no-underline-link">
              นโยบายความเป็นส่วนตัว
            </Link>
          </small>
        </div>

        

        {/* ===== ลิงก์ไปหน้า Login ===== */}
        <div className="text-center">
          มีบัญชีแล้ว?{" "}
          <Link to="/login" className="no-underline-link">
            เข้าสู่ระบบ
          </Link>
        </div>
      </div>
    </section>
  );
}

